<template>
  <div class="vue-wp-app">
    <!-- Admin Settings Page Component -->
    <template v-if="isAdmin && isPluginPage">

       <!-- User is a guest -->
    <div v-if="currentUser.is_guest && !$route.path.includes('/get-started')">
        <div class="flex justify-center items-center bg-primary rounded-box smart-press-notice">
          <div class="flex items-center gap-2">
            <figure class="bg-primary !m-0 !flex !items-center !justify-end !rounded-t-lg !mr-2">
            <img
                :src="pluginUrl + '/assets/smart-press-logo.png'"
                alt="Smartpress Logo"
                class="w-5"/>
            </figure>
            <p class="!text-secondary-content">
              Please Verify your email <i>{{ customFields.email }}</i> to increase your account limit. 
            </p>
            <button class="badge hover:scale-105 transition-all duration-300 cursor-pointer" @click="verifyEmail">Resend Verification Email</button>
          </div>
        </div>
      </div>

      <!-- If Secret Key is found, Authenticating user -->
      <div v-if="authenticating">
        <div class="flex justify-center items-center bg-primary rounded-box smart-press-notice">
          <div class="flex items-center gap-2">
            <figure class="bg-primary !m-0 !flex !items-center !justify-end !rounded-t-lg !mr-2">
            <img
                :src="pluginUrl + '/assets/smart-press-logo.png'"
                alt="Smartpress Logo"
                class="w-5"/>
            </figure>
            <p class="!text-secondary-content">
             Authenticating Details
            <span class="loading loading-dots loading-sm"></span>
            <br/>
            <small>Please wait & don't refresh the page while we authenticate your account.</small>
            </p>
          </div>
        </div>
      </div>

      <!-- Default View -->
       <!-- Hide if route is /get-started -->
      <div class="default-view">    
      <!-- Top Header -->
      <div v-if="!$route.path.includes('/get-started')" class="flex items-center bg-primary !text-secondary-content shadow-sm !rounded-lg !w-full min-h-16">
        <div class="flex-1">
          <div class="flex items-center">
            <img
              :src="pluginUrl + '/assets/smart-press-logo.png'"
              alt="Smartpress Logo"
              class="w-10 px-2"/>
              <a class="text-l !text-secondary-content font-bold">SmartPress 
              <small class="ml-2 badge badge-xs bg-green-200 border-0">
                {{ !currentUser.plan || currentUser.plan == "free" ? "Free" : currentUser.plan.charAt(0).toUpperCase() + currentUser.plan.slice(1) }}</small
              ></a>
          </div>
        </div>
        <div class="flex-none justify-end items-center">
          <ul class="menu menu-horizontal !pt-0">
            <router-link 
                v-for="route in routes" 
                :key="route.path" 
                :to="route.path"
                class="!text-secondary-content px-4 no-underline focus:!shadow-none !ease-in-out !transform hover:scale-115 !transition !duration-500 "
              >
              <!-- load route.icon svg -->
              <div class="flex items-center gap-2"><svg v-html="route.icon" class="w-5 h-5"></svg>  {{ route.name }}</div>
              </router-link>
            <li>
              <details>
                <summary class="!pt-0 mx-8 !pb-0">
                  <div class="flex items-center justify-center gap-2">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z" />
                </svg>
                  Account
                </div>
                </summary>
                <ul class="bg-primary rounded-t-none !p-2 z-10 !-ml-4">
                  <li><a class="!text-secondary-content no-underline" v-if="currentUser.plan !== 'free'" href="https://billing.stripe.com/p/login/7sIcNs83F7hk1MsaEE" target="_blank">Manage Subscription</a></li>
                  <li><a class="!text-secondary-content  no-underline" href="https://discord.gg/6xkcm4UcTx" target="_blank">Community & Support</a></li>
                  <li><a class="!text-secondary-content" @click="signOut">Sign Out</a></li>
                </ul>
              </details>
            </li>
          </ul>
        </div>
      </div>
      <!-- <nav class="admin-nav bg-primary !text-secondary-content rounded-lg" v-if="isPluginPage">
        <router-link 
          v-for="route in routes" 
          :key="route.path" 
          :to="route.path"
          class="link !text-secondary-content"
        >
          {{ route.name }}
        </router-link>
      </nav> -->
      <router-view></router-view>
    
    <!-- New Footer -->
    <footer v-if="!$route.path.includes('/get-started')" class="footer sm:footer-horizontal bg-neutral text-neutral-content items-center p-4 rounded-lg mt-8">
  <aside class="grid-flow-col items-center">
    <img :src="pluginUrl + '/assets/smart-press-logo.png'" alt="SmartPress Logo" class="w-10">
    <p><b>SmartPress V.{{ version }}</b> © {{new Date().getFullYear()}} - All right reserved</p>
  </aside>
  <nav class="grid-flow-col gap-4 md:place-self-center md:justify-self-end">
    <a href="https://10g8.com" target="_blank"><img :src="pluginUrl + '/assets/10g8-badge.png'" alt="10g8 Badge" class="h-10 mr-[-4px] hover:scale-110 transition-all duration-400"></a>
  </nav>
</footer>


      </div>
    </template>
    
    <!-- Default Component for other contexts -->
    <div v-else >
      
      <smartPressInit :customFields="customFields" />
      <smartChat v-if="customFields.global_chat" />
    </div>
      
      <!-- <p>Running in: {{ isAdmin ? 'WordPress Admin' : 'Frontend' }}</p> -->
      <!-- <p>Current page: {{ currentPage }}</p> -->

  </div>
</template>

<script>
import smartPressInit from './components/SmartPressInit.vue'
import smartChat from './components/smart-press/smartChat.vue'
import axios from 'axios';
export default {
  name: 'App',
  components: {
    smartPressInit,
    smartChat
  },
  data() {
    return {
      message: 'SmartPress Wordpress Plugin',
      isAdmin: false,
      isPluginPage: false,
      currentPage: '',
      menuSlugs: [],
      baseSlug: 'vue-wp-app',
      routes: [],
      version: '1.2.8',
      currentUser: localStorage.getItem('smartpress_current_user') ? JSON.parse(localStorage.getItem('smartpress_current_user')) : {},
      customFields: localStorage.getItem('smartpress_custom_fields') ? JSON.parse(localStorage.getItem('smartpress_custom_fields')) : {},
      wpUser: window.smartpress_wpUserData ? window.smartpress_wpUserData : {},
      authenticating: false,
      pluginUrl: window.smartpress_vars.pluginUrl || ''
    }
  },
  created() {
    // Get settings from WordPress
    const settings = window.smartpress_vueWpSettings || {}
    this.menuSlugs = settings.menuSlugs || [this.baseSlug]
    this.baseSlug = settings.baseSlug || this.baseSlug
    this.debugMode = settings.debugMode || false
    
    // Generate routes from menu items
    if (settings.menuItems) {
      this.routes = settings.menuItems.map(item => ({
        path: item.route,
        name: item.title,
        slug: item.slug,
        icon:  item.icon
      }))
      // console.log(settings.menuItems);
      // console.log(this.routes);
    }
    
    // Check if we're in the WordPress admin area
    this.isAdmin = window.location.href.includes('/wp-admin/')
    
    // Check if we're on any of the plugin pages
    if (this.isAdmin) {
      const urlParams = new URLSearchParams(window.location.search)
      const page = urlParams.get('page')
      
      // Check if current page is one of our plugin pages
      this.isPluginPage = this.menuSlugs.includes(page)
      this.currentPage = page || 'dashboard'
      
      // If we're on a plugin page, update the router path
      if (this.isPluginPage) {
        const routePath = this.getRoutePathFromSlug(page)
        if (routePath && routePath !== this.$route.path) {
          this.$router.push(routePath)
        }
      }

      // Debug logging
      if (this.debugMode) {
      console.log('Plugin page check:', {
        page,
        isPluginPage: this.isPluginPage,
        menuSlugs: this.menuSlugs,
        routePath: this.getRoutePathFromSlug(page)
      })
    }

    } else {
      this.currentPage = 'frontend'
    }
  },
  mounted() {
    // console.log("customFields",this.customFields);
    // console.log("currentUser",this.currentUser);
    if(this.customFields.email && this.customFields.api_key && this.currentUser.$id && !this.currentUser.is_guest){
      // User already authenticated
      // console.log("User already authenticated");
    }else{
      // console.log('Fetching custom fields');
      this.fetchCustomFields();
      
    }
  },
  methods: {
    async fetchCustomFields() {
      this.loading = true;
      this.error = null;
      
      try {
        // Step 1: Fetch custom fields from API
        await this.loadCustomFieldsFromApi();
        
        // Step 2: Check if we need authentication
        const needsAuthentication = this.checkIfAuthenticationNeeded();
        
        if (needsAuthentication) {
          // Step 3: Try to get secret key from URL
          const secretKey = this.extractSecretKeyFromUrl();
          
          if (secretKey) {
            // Step 4: Authenticate with secret key
            await this.authenticateWithSecretKey(secretKey);
          } else {
            // Step 5: Redirect to get-started if no secret key
            this.redirectToGetStarted();
          }
        }
      } catch (error) {
        console.error('Error fetching custom fields:', error);
        this.error = 'Failed to load Account Info, Please contact support.';
      } finally {
        this.loading = false;
      }
    },
    
    async loadCustomFieldsFromApi() {
      const baseUrl = this.wpUser.site_url;
      const response = await fetch(`${baseUrl}/wp-json/smartpress/v1/custom-fields`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-WP-Nonce': window.smartpress_wpApiSettings?.nonce || ''
        }
      });
      
      if (!response.ok) {
        throw new Error('Failed to fetch custom fields');
      }
      
      const data = await response.json();
      this.customFields = data;
      localStorage.setItem('smartpress_custom_fields', JSON.stringify(this.customFields));
    },
    
    checkIfAuthenticationNeeded() {
      return this.customFields.api_key.length < 1 || 
             !this.currentUser.$id || 
             this.customFields.email.length < 1 || 
             this.currentUser.is_guest;
    },
    
    extractSecretKeyFromUrl() {
      console.log("Hash:", window.location.hash);
      console.log("Search:", window.location.search);
      console.log("Route query:", this.$route.query);
      
      let secretKey = null;
      
      // Check Vue Router query params
      if (this.$route.query.secret) {
        secretKey = this.$route.query.secret;
      }
      
      return secretKey;
    },
    
    async authenticateWithSecretKey(secretKey) {
      this.authenticating = true;
      console.log("Secret key found, Authenticating user");
      this.customFields.api_key = secretKey;
      
      try {
        await this.getUserDetails();
        
        this.customFields.email = this.currentUser.email;
        this.customFields.is_guest = false;
        this.currentUser.is_guest = false;
        
        // Wait for trainAI promise to complete before saving custom fields
        const brandData = await this.trainAI();
        this.customFields.brand_data = brandData;
        
        localStorage.setItem('smartpress_current_user', JSON.stringify(this.currentUser));
        await this.saveCustomFields();
        
        console.log("REFRESHING PAGE");
        window.location.reload();
      } catch (error) {
        console.error("Error in authentication process:", error);
        this.authenticating = false;
        throw error;
      }
    },
    
    redirectToGetStarted() {
      console.log("No secret key found, redirecting to get-started page");
      console.log(this.customFields);
      console.log(this.currentUser);
      this.$router.push('/get-started');
    },
    async saveCustomFields() {
      console.log("Saving custom fields",this.customFields);
      this.saving = true;
      this.error = null;
      this.saveSuccess = false;
      
      let baseUrl = this.wpUser.site_url;
      try {
        const response = await fetch(`${baseUrl}/wp-json/smartpress/v1/custom-fields`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-WP-Nonce': window.smartpress_wpApiSettings?.nonce || ''
          },
          body: JSON.stringify(this.customFields)
        });
        
        if (!response.ok) {
          throw new Error('Failed to save custom fields');
        }
        console.log(response);
        
        const data = await response.json();
        this.customFields = data;
        // Add to local storage
        localStorage.setItem('smartpress_custom_fields', JSON.stringify(this.customFields));
        this.saveSuccess = true;
        
        // Hide success message after 3 seconds
        setTimeout(() => {
          this.saveSuccess = false;
        }, 3000);
      } catch (error) {
        console.error('Error saving custom fields:', error);
        this.error = 'Failed to save custom fields. Please try again later.';
      } finally {
        this.saving = false;
      }
    },
    async authenticateUser(email){
      console.log("Authenticating user",email || this.wpUser.user_email);
      try {
        const response = await axios.post('https://67d16eab6a70f6dfc533.10g8.cloud/auth', {
          name: this.wpUser.display_name,
          email: email ? email : this.wpUser.user_email ,
          url: this.wpUser.site_url
        });
        if(response.data.success){
          if(response.data.session){
            console.log("Authenticated user",response.data.session);
            this.customFields.api_key = response.data.session;
            this.customFields.email = email ? email : this.wpUser.user_email;
            this.saveCustomFields();
          }
          if(response.data.user){
            this.currentUser = response.data.user;
            localStorage.setItem('smartpress_current_user', JSON.stringify(this.currentUser));
          }
        }


      } catch (error) {
        console.error('Error authenticating user:', error);
    }
    },
    getRoutePathFromSlug(slug) {
      // Handle the main plugin page
      if (slug === this.baseSlug) return '/'
      
      // Find matching route for subpages
      const route = this.routes.find(r => 
        slug === this.baseSlug + r.slug
      )
      
      return route ? route.path : '/'
    },
    signOut(){
      this.customFields={
        email: '',
        api_key: '',
        email_verified: false
      };
      this.currentUser={};
      this.saveCustomFields();
      localStorage.removeItem('smartpress_current_user');
      localStorage.removeItem('smartpress_custom_fields');
      this.$router.push('/get-started');
    },
    async getUserDetails(retry = 0){
    const response = await axios.post('https://67d16eab6a70f6dfc533.10g8.cloud/whoami', {
      session: this.customFields.api_key,
      verify: true
    });
    if(response.data.success){
      this.currentUser = response.data.user;
    }else{
      // retry the request 2 more times
      if(retry < 2){
        setTimeout(() => {
          this.getUserDetails(retry + 1);
        }, 1000);
      }else{
        this.signOut();
      }
    }
    },
    verifyEmail(){
      this.currentUser.is_guest = false;
      this.authenticateUser(this.currentUser.email);
    },
    async trainAI() {
            // get website url
            const websiteUrl = window.location.origin;
            // const websiteUrl = 'https://smartpress.10g8.com';
            // check if websiteUrl is localhost
            if (websiteUrl.includes('localhost')) {
                return;
            }
            try{
                // send websiteUrl to server
            const response = await axios.post('https://node.10g8.com/webhook/14a134f2-33f3-4c5c-be5b-58d0a4eb3f2f', { "website":websiteUrl });

                let brandData = response.data.output;
                return brandData;
            }catch(error){
                return false;
            }
            

        }
  }
}
</script>

<style>
/* Make sure you don't have styles that could override Tailwind */
/* If you have a <style> block with CSS that might conflict, modify it */
/* .vue-wp-app {
  padding: 20px;
  background: #f0f0f0;
  margin: 10px;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
} */

.admin-nav {
  margin-bottom: 20px;
  padding: 10px 0;
  border-bottom: 1px solid #ddd;
}

.nav-link {
  margin-right: 15px;
  padding: 5px 10px;
  text-decoration: none;
  color: #444;
}

.nav-link.router-link-active {
  color: #2271b1;
  font-weight: bold;
}

.default-view {
  padding: 20px;
  margin: 20px;
  /* background: #f0f0f0; */
  /* border-radius: 4px; */
  /* box-shadow: 0 2px 4px rgba(0,0,0,0.1); */
}

</style> 